import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/section-divider.svg'


const _hoisted_1 = { class: "component section-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "section-divider",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass([['large-text', _ctx.textClass], "section-text"])
    }, _toDisplayString(_ctx.text), 3),
    _hoisted_2
  ]))
}